import React, { useState, useEffect } from 'react';
import { avatarCache, onAvatarsLoaded } from '../../utils/avatars';
import './SteamAvatar.css';

const SteamAvatar = ({ steamid64, name, size = 'medium' }) => {
  const [, forceUpdate] = useState(0);
  const sizeClass = size === 'large' ? 'avatar-large' : size === 'small' ? 'avatar-small' : 'avatar-medium';

  useEffect(() => {
    const unsubscribe = onAvatarsLoaded(() => forceUpdate(n => n + 1));
    return unsubscribe;
  }, []);

  const avatarUrl = avatarCache[steamid64];

  const getColorFromId = (id) => {
    const colors = ['#ff6b00', '#00d4ff', '#4ade80', '#fbbf24', '#f472b6', '#a78bfa', '#34d399', '#fb923c'];
    const index = Math.abs(parseInt(String(id).slice(-2))) % colors.length;
    return colors[index];
  };

  const initial = name ? name.charAt(0).toUpperCase() : '?';
  const bgColor = getColorFromId(steamid64);

  if (avatarUrl) {
    return (
      <div className={`steam-avatar ${sizeClass}`} title={name}>
        <img src={avatarUrl} alt={name} />
      </div>
    );
  }

  return (
    <div
      className={`steam-avatar ${sizeClass}`}
      style={{ backgroundColor: bgColor }}
      title={name}
    >
      <span className="avatar-initial">{initial}</span>
    </div>
  );
};

export default SteamAvatar;
